import { render } from "./Shows.vue?vue&type=template&id=1392f7c2&scoped=true"
import script from "./Shows.ts?vue&type=script&lang=js"
export * from "./Shows.ts?vue&type=script&lang=js"

import "./Shows.vue?vue&type=style&index=0&id=1392f7c2&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1392f7c2"]])

export default __exports__